import { render } from "./OrthodonticsView.vue?vue&type=template&id=1f411b1f&scoped=true"
import script from "./OrthodonticsView.vue?vue&type=script&lang=js"
export * from "./OrthodonticsView.vue?vue&type=script&lang=js"

import "./OrthodonticsView.vue?vue&type=style&index=0&id=1f411b1f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f411b1f"]])

export default __exports__